export const staircaseConfig = {
    gameSlug: 'jol-confidence',
    category: 'foudre_logique',
    variable: 'n_items',
    startValue: 8,
    minValue: 4,
    maxValue: 16,
    stepSizesByPhase: [2, 1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    /** 1 trial = 1 bloc (~ 1-2 min) ; on cap à 5 (~ 5-10 min). */
    maxTrials: 5,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            pairsCount: 6,
            distractorMs: 10_000,
            difficulty: 1,
            targetGamma: 0.3,
            label: 'Concrètes associées',
        };
    }
    if (level <= 20) {
        return {
            level,
            pairsCount: 8,
            distractorMs: 15_000,
            difficulty: 2,
            targetGamma: 0.3,
            label: 'Concrètes mixtes',
        };
    }
    if (level <= 30) {
        return {
            level,
            pairsCount: 10,
            distractorMs: 20_000,
            difficulty: 3,
            targetGamma: 0.3,
            label: 'Semi-abstraites',
        };
    }
    if (level <= 40) {
        return {
            level,
            pairsCount: 12,
            distractorMs: 25_000,
            difficulty: 4,
            targetGamma: 0.4,
            label: 'Abstraites peu liées',
        };
    }
    return {
        level,
        pairsCount: 16,
        distractorMs: 30_000,
        difficulty: 5,
        targetGamma: 0.4,
        label: 'Arbitraires',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    studyPerPairMs: 4_000,
    feedbackMs: 1500,
    itiMs: 1000,
};
export const paradigmMeta = {
    slug: 'jol-confidence',
    paradigm: 'Judgment of Learning (Nelson & Dunlosky 1991)',
    category: 'metacog',
    goal: 'Apprends, prédis ton rappel, vérifie ton intuition.',
};
//# sourceMappingURL=params.js.map